import React from 'react'
import styles from './styles/separator.module.scss'
import classNames from 'classnames'

const Separator = ({ className = '' }: { className?: string }) => {
  return <hr aria-hidden className={classNames(styles.horizontalSeparator, className)}></hr>
}

export default Separator
